import { ComponentVersion } from "../assessmentEngineConfig";
import { PlatformComponent } from "../services/platform/types";
import { ConditionsMapV2, ConditionsMapV3 } from "./assessmentTypeConditionsMap";
import { Assessment } from "./assessmentTypes";
import { AssessmentComponent } from "./componentTypes";
import { ComponentConditionKey } from "./conditions";
import { TypedAssessment } from "./typedAssessment";

export function GetAssessmentInstance(
	assessmentKey: AssessmentComponent,
	assessmentId: string,
	component: PlatformComponent,
	componentVersion: ComponentVersion,
): Assessment | null {
	const ConditionsMap = componentVersion === "2" ? ConditionsMapV2 : ConditionsMapV3;
	if (assessmentKey && ConditionsMap[assessmentKey]) {
		const conditionType = ConditionsMap[assessmentKey];
		return new TypedAssessment<ComponentConditionKey>(
			assessmentKey,
			assessmentId,
			component,
			Object.values(conditionType),
		);
	}
	return null;
}
